import { render, staticRenderFns } from "./RemoveFormModal.vue?vue&type=template&id=584484b8&"
import script from "./RemoveFormModal.vue?vue&type=script&lang=js&"
export * from "./RemoveFormModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveFormModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports